import { Image, Platform, StyleSheet, View, ViewProps } from 'react-native';
import { Text, useTheme } from '@ui-kitten/components';

import MarkdownText from './MarkdownText';
import React from 'react';
import tw from 'twrnc';
import { UIHelper as uh } from '../../core';
import { useAppStore } from 'src/core/store';

//props
interface IKaliQuoteProps extends ViewProps {
  heading: string;
  caption: string;
  onLinkPress?: (url: string) => boolean;
}

const KaliQuote = (props: IKaliQuoteProps) => {
  //styles
  const th = useTheme();
  const theme = useAppStore((state) => state.theme);
  const condColors = {
    quote: uh.getHex(th, theme, 'color-basic-400', 'color-basic-800')
  };

  const styleContainer = StyleSheet.create({
    icon: { width: 40, height: 40, marginRight: 8 },
    quote: {
      flex: 1,
      padding: 16,
      backgroundColor: condColors.quote,
      borderRadius: 16,
      borderTopLeftRadius: 0
    },
    caption: { paddingTop: 4 }
  });

  const markdownStyles = StyleSheet.create({
    view: {
      marginTop: Platform.OS === 'web' ? 0 : -8,
      marginBottom: Platform.OS === 'web' ? 0 : -14
    },
    text: {
      color: th['text-basic-color'],
      fontSize: 14,
      fontWeight: '400',
      fontFamily: 'Poppins-Regular'
    },
    strong: {
      fontSize: 14
    }
  });

  //views
  return (
    <View style={[tw`flex-row`, props.style]}>
      <View style={styleContainer.icon}>
        <Image
          style={{ width: '100%', height: '100%' }}
          source={require('../../../assets/images/brand/chatbot-avatar.png')}
        />
      </View>
      <View style={styleContainer.quote}>
        <Text category="h6">{props.heading}</Text>
        <MarkdownText styles={markdownStyles}>{props.caption}</MarkdownText>
      </View>
    </View>
  );
};

export default KaliQuote;
